/*
 * patient-lp-enrollment (schema)
 *
 * Stores per-patient, per-producer LP Client IDs assigned by the LP.
 * One row per (patient, producer) pair — updated in place when the ID changes.
 */
import { boolean, timestamp, unique, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { producers } from "../producer/producer.schema"
import { users } from "../user/user.schema"

export const patientLpEnrollments = schema.table(
	"patient_lp_enrollments",
	{
		id: uuid("id").primaryKey().notNull().defaultRandom(),

		patientId: uuid("patient_id")
			.notNull()
			.references(() => patients.id, { onDelete: "cascade" }),
		producerId: uuid("producer_id")
			.notNull()
			.references(() => producers.id, { onDelete: "cascade" }),

		lpClientId: varchar("lp_client_id", { length: 128 }),
		pendingLpClientId: varchar("pending_lp_client_id", { length: 128 }),

		active: boolean("active").notNull().default(true),
		createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
		updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
		createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
		updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
	},
	(t) => ({
		uniquePatientProducer: unique("patient_lp_enrollments_patient_producer_unique").on(
			t.patientId,
			t.producerId,
		),
	}),
)
